import { CorporateSectionData } from './interface/interface';
import IndividualImg from '../assets/images/individuals.png';
import LegalConsultationIcon from '../assets/images/components/LegalConsultationIcon';
import LitigationIcon from '../assets/images/components/LitigationIcon';
import PropertyConveyIcon from '../assets/images/components/PropertyConveyIcon';
import SmartLegalToolsIcon from '../assets/images/components/SmartLegalToolsIcon';

export const individualSectionData: CorporateSectionData = {
  info: {
    image: IndividualImg,
    para1:
      'Navigating legal issues as an individual can be overwhelming, especially without the right guidance. At Legalligence, we bridge the gap between individuals and accessible legal support by combining expert advice with smart technology.',
    para2:
      'Whether you’re dealing with cybercrime, consumer complaints, data privacy breaches, employment issues, or personal disputes, our platform simplifies complex legal processes and helps you take informed action—quickly and confidently.',
  },
  desc: [
    {
      title: 'Expert-Backed Advice',
      description: 'Access trusted legal guidance tailored to your personal concerns.',
    },
    {
      title: 'Smart Legal Technology',
      description: 'AI-assisted tools for faster research and simplified processes.',
    },
    {
      title: 'Clarity & Confidence',
      description: 'Empowering you to take informed decisions with ease.',
    },
  ],
  cards: [
    {
      icon: <LegalConsultationIcon />,
      heading: 'Legal Consultation',
      content:
        'Direct access to expert legal advice for individuals seeking clarity and solutions.',
    },
    {
      icon: <LitigationIcon />,
      heading: 'Litigation & Non-Litigation Support',
      content:
        'Comprehensive back-end assistance for both contentious and non-contentious legal needs.',
    },
    {
      icon: <PropertyConveyIcon />,
      heading: 'Property Conveyances & Opinions',
      content:
        'Specialized services for property transactions, including legal opinions and documentation.',
    },
    {
      icon: <SmartLegalToolsIcon />,
      heading: 'Smart Legal Tools',
      content:
        'AI-powered research and document drafting for faster, affordable, and personalized support.',
    },
  ],
};
